<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('superior') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid field">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Employee_Id" class="col-3">{{ $t('nik') }}<span style="color:red">*</span></label>
                                <div class="col-9 md-9">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Employee_Id" v-if="header"
                                                  :filter="true" :url="this.$API_URL + 'list/employee_id'" :minLength="0"
                                                  :disabled="mode != this.$FORM_MODE_CREATE" :params="{}"
                                                  :class="{ 'p-invalid': submitted && !header.Employee_Id }"
                                                  @change="changeEmployee($event)" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Employee_Id && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('nik')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && header.Layer">
                                <div class="col-3"></div>
                                <div class="col-9 md-9">
                                    <InputText name="Email_Employee" v-model="header.Email_Employee" type="text"
                                               :placeholder="$t('email')" v-if="header" :disabled="true" />
                                    <Skeleton v-else />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid" v-if="header && !header.Layer">
                                <div class="col-8 md-8">
                                    <InputText name="Email_Employee" v-model="header.Email_Employee" type="text"
                                               :placeholder="$t('email')" v-if="header" :disabled="true" />
                                    <Skeleton v-else />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid field">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="NIK_Approval1" class="col-3">{{ $t('superior1') }}<span style="color:red">*</span></label>
                                <div class="col-9 md-9">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Approval1" v-if="header"
                                                  :filter="true" :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                  :params="{ excempId: header.Employee_Id }"
                                                  :class="{ 'p-invalid': submitted && !header.NIK_Approval1 }"
                                                  @change="changeSuperior1($event)" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.NIK_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('superior1')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && header.Layer">
                                <div class="col-3"></div>
                                <div class="col-9 md-9">
                                    <InputText name="Email_Approval1" v-model="header.Email_Approval1" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Approval1 }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid" v-if="header && header.Layer == 'SUPERIOR'">
                                <label for="NIK_Functional" class="col-3">{{ $t('functional') }}<span style="color:red">*</span></label>
                                <div class="col-9 md-9">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Functional" v-if="header"
                                                  :filter="true" :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                  :params="{ excempId: header.Employee_Id }"
                                                  :class="{ 'p-invalid': submitted && !header.NIK_Functional }"
                                                  @change="changeFunctional($event)" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.NIK_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('functional')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && header.Layer == 'SUPERIOR'">
                                <div class="col-3"></div>
                                <div class="col-9 md-9">
                                    <InputText name="Email_Functional" v-model="header.Email_Functional" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Functional }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && !header.Layer">
                                <div class="col-8 md-8">
                                    <InputText name="Email_Approval1" v-model="header.Email_Approval1" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Approval1 }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Approval1 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="grid field">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="NIK_Approval2" class="col-3">{{ $t('superior2') }}<span style="color: red;">*</span></label>
                                <div class="col-9 md-9">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Approval2" :filter="true"
                                                  :class="{ 'p-invalid': submitted && !header.NIK_Approval2 }" v-if="header"
                                                  :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                  :params="{ excempId: header.Employee_Id }"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                  @change="changeSuperior2($event)" />
                                    <small v-if="header && !header.NIK_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('superior2')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && header.Layer">
                                <div class="col-3"></div>
                                <div class="col-9 md-9">
                                    <InputText name="Email_Approval2" v-model="header.Email_Approval2" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Approval2 }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" style="padding-top: 5px;">
                                <label for="Period_Year" class="col-3">{{ $t('period') }}<span style="color: red;">*</span></label>
                                <div class="col-9 md-9">
                                    <Dropdown v-model="header.Period_Year" v-if="header" :options="years"
                                              optionLabel="value" optionValue="value" :placeholder="$t('year')"
                                              :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT)"
                                              :class="{ 'p-invalid': submitted && !header.Period_Year }" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Period_Year && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('period')) }}</small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Active" class="col-3">{{ $t('active') }}</label>
                                <div class="col-9 md-9">
                                    <ToggleButton v-model="header.Active" onLabel="Yes" offLabel="No"
                                                  :style="{ width: '10em' }" v-if="header"
                                                  :class="{ 'p-invalid': submitted && !header.Active }"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <Skeleton v-else />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="ChangeOnTransaction" class="col-3">{{ $t('ChangeOnTransaction') }}</label>
                                <div class="col-9 md-9">
                                    <ToggleButton v-model="header.ChangeOnTransaction" onLabel="Yes" offLabel="No"
                                                  :style="{ width: '10em' }" v-if="header"
                                                  :class="{ 'p-invalid': submitted && !header.ChangeOnTransaction }"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                  v-tooltip.bottom="'Click here to adjust the flow approval of apraisal'" />
                                    <Skeleton v-else />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid" v-if="header && header.Layer == 'HEAD SUPERIOR'">
                                <label for="NIK_Functional" class="col-3">{{ $t('functional') }}<span style="color:red">*</span></label>
                                <div class="col-9 md-9">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.NIK_Functional" v-if="header"
                                                  :filter="true" :url="this.$API_URL + 'list/employee_no'" :minLength="0"
                                                  :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                  :params="{ excempId: header.Employee_Id }"
                                                  :class="{ 'p-invalid': submitted && !header.NIK_Functional }"
                                                  @change="changeFunctional($event)" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.NIK_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('functional')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && header.Layer == 'HEAD SUPERIOR'">
                                <div class="col-3"></div>
                                <div class="col-9 md-9">
                                    <InputText name="Email_Functional" v-model="header.Email_Functional" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Functional }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Functional && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>
                            <div class="field grid" v-if="header && !header.Layer">
                                <div class="col-8 md-8">
                                    <InputText name="Email_Approval2" v-model="header.Email_Approval2" type="text"
                                               :placeholder="$t('email')" v-if="header"
                                               :class="{ 'p-invalid': submitted && !header.Email_Approval2 }"
                                               :disabled="true" />
                                    <Skeleton v-else />
                                    <small v-if="header && !header.Email_Approval2 && submitted && mode != this.$FORM_MODE_DELETE"
                                           class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}</small>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "SuperiorIndex",
            url: this.$API_URL + "superior/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    if (response.data.success) {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Employee Superior has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Employee Superior has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Superior/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            if (!this.header.Employee_Id || !this.header.NIK_Approval1 || !this.header.NIK_Approval2 || !this.header.Period_Year || !this.header.Email_Approval1 || !this.header.Email_Approval2) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {

                    }
                });
            }

        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        changeEmployee: function (e) {
            if (e == null) {
                this.header.Email_Employee = "";
            }
            else {
                this.header.Email_Employee = e.email;
                this.header.Layer = e.Layer;
            }
        },
        changeSuperior1: function (e) {
            if (e == null) {
                this.header.Email_Approval1 = "";
            }
            else {
                this.header.Email_Approval1 = e.email;
            }
        },
        changeSuperior2: function (e) {
            if (e == null) {
                this.header.Email_Approval2 = "";
            }
            else {
                this.header.Email_Approval2 = e.email;
            }
        },
        changeFunctional: function (e) {
            if (e == null) {
                this.header.Email_Functional = "";
            } else {
                this.header.Email_Functional = e.email;
            }
        },        
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    },
    computed: {
        years() {
            let years = [];

            for (var i = new Date().getFullYear(); i <= new Date().getFullYear() + 20; i++) {
                years.push({ value: i.toString() })
            }
            return years;
        }
    }
}
</script>

<style scoped>
    .grid.field + .grid.field {
    margin-top: .25rem;
    }

</style>